import { MapContainer, TileLayer, Marker, Circle, AttributionControl, Polygon } from 'react-leaflet'
import { selectMapOptions, updateMapOption } from './mapSlice'
import { getMapDistanceAndMapCenter } from 'utils/map'
import { useDispatch, useSelector } from 'react-redux'
import { updateLocation } from '../menu/filtersSlice'
import { useEffect, useRef, useState } from 'react'
import { locationIcon } from './assets/customIcon'
import useTranslation from 'hooks/useTranslation'
import { selectLightTheme } from 'appSlice'
import { voivodships } from './voivodships'
import { DISTANCE_LIST } from './mapUtils'
import Markers from './Markers'

import 'react-leaflet-markercluster/dist/styles.min.css'
import 'leaflet/dist/leaflet.css'

const DELAY = 500
const Map = ({ isDesktop = false, showMapButton = true }) => {
  const { position, mapPosition, zoom, showMarker, distance, voivodship } = useSelector(selectMapOptions)
  const lightTheme = useSelector(selectLightTheme)
  const [isButton, showButton] = useState(false)
  const [isReady, setIsReady] = useState(false)

  const mapRef = useRef(null)
  const timeout = useRef(null)
  const blockListener = useRef(false)

  const dispatch = useDispatch()
  const { t } = useTranslation('map')

  useEffect(() => {
    if (mapRef.current && mapPosition) {
      blockListener.current = true
      mapRef.current.flyTo(mapPosition, zoom)
      showButton(false)
    }
  }, [mapPosition, zoom])

  useEffect(() => {
    const onMoveEnd = (e) => {
      if (blockListener.current) {
        blockListener.current = false

      } else {
        if (timeout.current) {
          clearTimeout(timeout.current)
        }
        timeout.current = setTimeout(() => {
          showButton(true)
        }, DELAY)
      }
    }

    const map = mapRef.current
    if (map && !isButton && showMapButton) {
      map.addEventListener('moveend', onMoveEnd)
      return () => {
        map.removeEventListener('moveend', onMoveEnd)
      }
    }
  }, [isButton, isReady, showMapButton])

  return (
    <>
      <MapContainer
        className='map'
        zoom={zoom}
        maxZoom={18}
        scrollWheelZoom
        zoomControl={false}
        attributionControl={false}
        center={mapPosition || [52.11, 19.21]}
        whenCreated={map => {
          mapRef.current = map
          setIsReady(true)
        }}>

        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url={`https://{s}.basemaps.cartocdn.com/${lightTheme ? 'light' : 'dark'}_all/{z}/{x}/{y}{r}.png?key=${process.env.REACT_APP_CARTO_KEY}`}
          subdomains='abcd'
        />

        <AttributionControl position={isDesktop ? 'bottomright' : 'topright'} prefix={false} />

        {voivodship !== undefined && <Polygon
          positions={voivodships[voivodship]}
          pathOptions={{ fillColor: 'var(--primary-color)', color: 'var(--primary-color)' }} />}

        {position && showMarker && <Marker
          icon={locationIcon}
          position={position} />}

        {position && distance && <Circle
          center={position}
          radius={distance * 1000}
          pathOptions={{ fillColor: 'none', color: 'var(--primary-color)' }} />}

        <Markers
          mapRef={mapRef}
          lightTheme={lightTheme}
        />
      </MapContainer>
      {isButton && <div
        className='map__findLocationsButton'
        onClick={() => {
          if (mapRef.current) {
            const { center, distance } = getMapDistanceAndMapCenter(mapRef.current)
            const validDistance = DISTANCE_LIST.reduce((r, e) => Math.abs(r - distance) < Math.abs(e - distance) ? r : e, DISTANCE_LIST[0])
            dispatch(updateLocation(t('locationFromTheMap')))
            dispatch(updateMapOption({
              position: [center.latitude, center.longitude],
              distance: validDistance,
              showMarker: true
            }))
          }
        }}>
        <span>{t('searchThisArea')}</span>
      </div>}
    </>
  )
}

export default Map